/**
 * Created by dosborne on 20/05/17.
 */
export default {
    googleMapsApiKey: 'AIzaSyDx7IpeIvuDfF4b5VdzuIURhN7nOlMt73Q',
    twitterAppKey: 'CDB25MdGt6902kyJSUtOSevsB'
}


// WEBPACK FOOTER //
// ./src/env.js